import { captureException } from '@sentry/nextjs';
import type { GetStaticPropsContext, NextPage } from 'next';
import { fetchContentfulPage } from '../lib/static/fetchStaticPage';
import type { StaticPageData } from '../lib/static/page';
import { DEFAULT_PAGE_TTL } from '../lib/static/static-page';
import { ERRORS } from '../lib/utils/errors';
import { PageTemplate } from '../page-templates/generic-page';
export const getStaticPaths = async () => {
  // not sure how to query just these paths yet, so build and cache them on demand only

  return {
    paths: [],
    fallback: 'blocking'
  };
};
export async function getStaticProps(context: GetStaticPropsContext) {
  try {
    // join all the slug parts into a single string
    const slug = (context?.params?.slug as string[])?.join('/').toLowerCase();

    // dont try to look up assets (foo.js, bar.css, baz.png) in contentful
    if (slug.includes('.')) {
      return {
        notFound: true
      };
    }

    // get the page object from contentful
    const data = await fetchContentfulPage(slug);
    if (!data) {
      return {
        notFound: true
      };
    }
    return {
      props: {
        data,
        slug
      },
      revalidate: DEFAULT_PAGE_TTL
    };
  } catch (error) {
    if (error instanceof Error && error.message.startsWith(ERRORS.PAGE_NOT_FOUND)) {
      return {
        notFound: true
      };
    }
    captureException(error);
    throw error;
  }
}
const CatchAllPage: NextPage<StaticPageData> = ({
  data,
  slug
}) => {
  // This seems to be necessary because `data` is not available on first render
  if (!data) return null;
  return <PageTemplate slug={slug} pageData={data} data-sentry-element="PageTemplate" data-sentry-component="CatchAllPage" data-sentry-source-file="[...slug].tsx" />;
};
export default CatchAllPage;